import axios from '@/app/plugins/Axios'

import qs from "qs";

export default new class ChequesService {

  listar(lista) {
    if (lista) lista = '?lista=' + lista;
    else lista = '';
    
    return axios.get('cheques' + lista)
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/cheques/' + id)
      .then(response => response.data);
  }

  salvar(cheque) {
    return axios.post('/cheques', cheque)
      .then(response => response.data);
  }

  atualizar(cheque) {
    return axios.put('/cheques/'+ cheque.id, cheque)
      .then(response => response.data)
  }

  excluir(id) {
    return axios.delete('/cheques/' + id)
      .then(response => response.data);
  }

  emitente(cpfcnpj) {
    return axios.get('/cheques/emitente?cpfcnpj=' + cpfcnpj)
      .then(response => response.data);
  }

  atualizarStatusCheque(cheque) {
    return axios.put('/cheques/'+ cheque.id + '/atualizarstatus', cheque)
      .then(response => response.data);
  }

  filtrarCheques(filtro) {
    return axios.get('/cheques/filtrar?'+ qs.stringify(filtro))
      .then(response => response.data);
  }
}
